import { render, staticRenderFns } from "./DocumentInfo.vue?vue&type=template&id=c5e1cf76&scoped=true&"
import script from "./DocumentInfo.vue?vue&type=script&lang=js&"
export * from "./DocumentInfo.vue?vue&type=script&lang=js&"
import style0 from "./DocumentInfo.vue?vue&type=style&index=0&id=c5e1cf76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5e1cf76",
  null
  
)

export default component.exports